<template lang="pug">
  div.highlight-text-container(
    :class="{ [className]: className }"
    v-if="text && textParts.length > 0"
  )
    template(v-for="item in textParts")
      span.normal-text(
        :class="{ 'highlight-text': item.highlight }"
        :style="item.highlight ? highlightStyle : normalStyle"
      ) {{ item.text }}
</template>

<script>
import { safeJsonStringify } from '@/utils/tools';

export default {
  name: 'HighlightText',
  props: {
    // 自定义类名
    className: {
      type: String,
      default: '',
    },
    // 文本
    text: {
      type: String,
      default: '',
    },
    // 普通文本样式
    normalStyle: {
      type: Object,
      default: () => ({}),
    },
    // 高亮文本样式
    highlightStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // 文本片段
      textParts: [],
    };
  },
  mounted() {
    this.processedParts();
  },
  methods: {
    // 拆解文本
    processedParts() {
      try {
        const regex = /\{([^}]+)\}/g;
        const parts = [];
        let lastIndex = 0;
        let match = regex.exec(this.text);

        while (match) {
          // 添加非高亮部分
          if (match.index > lastIndex) {
            const handleText = this.text.slice(lastIndex, match.index) || '';
            parts.push({
              text: handleText.replace(/\{|\}/g, ''),
              highlight: false,
            });
          }

          // 添加高亮部分
          parts.push({
            text: match[0].replace(/\{|\}/g, ''),
            highlight: true,
          });

          lastIndex = match.index + match[0].length;
          match = regex.exec(this.text);
        }

        // 添加剩余部分
        if (lastIndex < this.text.length) {
          const handleText = this.text.slice(lastIndex) || '';
          parts.push({
            text: handleText.replace(/\{|\}/g, ''),
            highlight: false,
          });
        }

        this.textParts = parts;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(
          'HighlightText processedParts => error',
          safeJsonStringify(error),
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
.highlight-text-container {
  .normal-text {
    font-weight: 500;
    font-size: 0.14rem;
    color: #623f00;
  }

  .highlight-text {
    color: #ff5c0a;
  }
}
</style>
